import RecievedListBody from "components/CRMComponents/CRMConversationComponents/RecievedComponents/RecievedListBody/RecievedListBody";
import Header from "components/Common/Header/Header";
import React, { useEffect } from "react";

const CrmConversationRecievedList = () => {
  useEffect(() => {
    document.title = "Recieved Mail Conversation";
  }, []);
  return (
    <main id="app">
      {/* ---- header component ---- */}
      <Header moduleName="crm" />

      {/* --- body component --- */}
      <RecievedListBody />
    </main>
  );
};

export default CrmConversationRecievedList;
